import { render } from "./shopListManage.vue?vue&type=template&id=5ec0f9b0"
import script from "./shopListManage.vue?vue&type=script&lang=js"
export * from "./shopListManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__